import React, { useState, useEffect } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { TextBoxComponent, NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import axios from "axios";
import { Fetch, FetchFileUpload } from "../services/dataservice";
import { connect } from 'react-redux';
import { signin, customer } from "../redux/action/login.action";

function UpdateProfileNew({ history, loginStatus, loginInfo }) {
    const location = useLocation();
    const [selectedFile, setSelectedFile] = useState(null);
    const [allStates, setAllStates] = useState([]);
    const [checkBoxStatus, setCheckBoxStatus] = useState(false);
    const [customerData, setCustomerData] = useState({
        customerID: 0,
        email: null,
        password: null,
        firstName: null,
        lastName: null,
        phone: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        zip: null
    });
    const [petData, setPetData] = useState({
        petID: 0,
        customerID: 0,
        petName: null,
        petType: null,
        breed: null,
        ageYear: 0,
        ageMonth: 0,
        weight: 0,
        color: null,
        gender: null,
        imageName: null
    });
    const gender = [
        { Id: 1, Type: 'Male' },
        { Id: 2, Type: 'Female' }        
    ];
    const petType = [
        { Id: 1, Type: 'Cat' },
        { Id: 2, Type: 'Dog' }        
    ];
    const genderfields = { text: 'Type', value: 'Type' };
    const petTypefields = { text: 'Type', value: 'Type' };

    useEffect(() => {
        if (location.state === undefined) {
            history.push('/member-registration');
        } else {
            customerData.email = location.state.email;
            customerData.password = location.state.password;
        }

        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/States/GetState`)
            .then((response) => {
                setAllStates(response.data);
            });
    }, []);    

    const statefields = { text: 'stateName', value: 'stateCode' };

    const handleStateChange = (e, property) => {
        setCustomerData({ ...customerData, [property]: e.target.value });
    };
    const handleCheckBoxChange = e => {
        setCheckBoxStatus(e.target.checked);
    };
    const handleChange = (e, property) => {
        setCustomerData({ ...customerData, [property]: e.target.value });
    };
    const handleChangePet = (e, property) => {
        setPetData({ ...petData, [property]: e.target.value });
    };
    const handleChangeInt = (e, property) => {
        setPetData({ ...petData, [property]: parseInt(e.target.value) });
    };
    const handleChangeFloat = (e, property) => {
        setPetData({ ...petData, [property]: parseFloat(e.target.value) });
    };
    const handleFileChange = e => { 
        setSelectedFile(e.target.files[0]);      
    };

    const handleUpdateProfile = async () => {
        try {
            let customerId = await Fetch(`/Customer/Add`, "post", customerData);
            if (customerId > 0) {
                petData.customerID = customerId;
                if (!checkBoxStatus) {
                    //uploadFiles();
                    if (selectedFile) {
                        const formData = new FormData()
                        formData.append('file', selectedFile, selectedFile.name)   //the name 'file' must match the name of the parameter in the controller's action                
                        let result = await FetchFileUpload(`/File/Upload`, "post", formData);
                        if (result.status == 'success') {
                            petData.imageName = selectedFile.name;
                        }
                    }
                    // 

                    let petId = await Fetch(`/PetInformation/Add`, "post", petData);
                    if (petId > 0) {
                        alert("Updated successfully.");
                    } else {
                        alert("Error on pet registration.");
                    }
                }

                const cust = [{ custId: customerId, fName: customerData.firstName }];
                loginInfo(cust);
                loginStatus(true);

                history.push("/member");
                // history.push({
                //     pathname: '/member',
                //     state: customerId
                // })
            } else {
                alert("Error on owner registration.");
                history.push('/member-registration');
            }
        }
        catch (ex) {
            alert("Error...");
        }
    };

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Update Profile</h3>
                    </div>
                    <div class="col-md-12">
                        <h4 style={{ color: "#f19f1f", width: "100%" }}>Owner Profile</h4>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>First Name</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.firstName} onChange={(e) => handleChange(e, "firstName")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Last Name</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.lastName} onChange={(e) => handleChange(e, "lastName")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Phone</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.phone} onChange={(e) => handleChange(e, "phone")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Email</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.email} readOnly="true" />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Address Line 1</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.address} onChange={(e) => handleChange(e, "address")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Address Line 2</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.address1} onChange={(e) => handleChange(e, "address1")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>City</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.city} onChange={(e) => handleChange(e, "city")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>State</label>
                        <DropDownListComponent
                            id="ddlState"
                            cssClass="e-outline"
                            dataSource={allStates}
                            fields={statefields}
                            value={customerData.state}
                            onChange={(e) => handleStateChange(e, "state")}
                            placeholder="---Select---"
                            popupHeight="250px"
                        />                        
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Zip</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.zip} onChange={(e) => handleChange(e, "zip")} />
                    </div>
                    <div class="col-md-12 form-group">
                        <CheckBoxComponent label="I have no pets" checked={checkBoxStatus} onChange={handleCheckBoxChange} />
                    </div>
                    {!checkBoxStatus ?
                        <div>
                            <div class="col-md-12">
                                <h4 style={{ color: "#f19f1f", width: "100%" }}>Pet Profile</h4>
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Pet Name</label>
                                <TextBoxComponent cssClass="e-outline" value={petData.petName} onChange={(e) => handleChangePet(e, "petName")} />
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Pet Type</label>
                                <DropDownListComponent
                                    cssClass="e-outline"
                                    dataSource={petType}
                                    fields={petTypefields}
                                    value={petData.petType}
                                    onChange={(e) => handleChangePet(e, "petType")}
                                    placeholder="---Select---"
                                />
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Breed</label>
                                <TextBoxComponent cssClass="e-outline" value={petData.breed} onChange={(e) => handleChangePet(e, "breed")} />
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Gender</label>
                                <DropDownListComponent
                                    cssClass="e-outline"
                                    dataSource={gender}
                                    fields={genderfields}
                                    value={petData.gender}
                                    onChange={(e) => handleChangePet(e, "gender")}
                                    placeholder="---Select---"
                                />
                            </div>
                            <div class="col-md-2 form-group">
                                <label>Age: Year</label>
                                <NumericTextBoxComponent format='###' min={0} cssClass="e-outline" value={petData.ageYear} onChange={(e) => handleChangeInt(e, "ageYear")} />
                            </div>
                            <div class="col-md-2 form-group">
                                <label>Month</label>
                                <NumericTextBoxComponent format='###' min={0} max={11} cssClass="e-outline" value={petData.ageMonth} onChange={(e) => handleChangeInt(e, "ageMonth")} />
                            </div>
                            <div class="col-md-2 form-group">
                                <label>Weight</label>
                                <NumericTextBoxComponent format='###.## lb' min={0} max={500} validateDecimalOnType={true} decimals={2}
                                    cssClass="e-outline" value={petData.weight} onChange={(e) => handleChangeFloat(e, "weight")} />
                            </div>
                            <div class="col-md-2 form-group">
                                <label>Color</label>
                                <TextBoxComponent cssClass="e-outline" value={petData.color} onChange={(e) => handleChangePet(e, "color")} />
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Upload Pet Image(only .jpg or .png)</label>
                                <input className="browse-img" type="file" onChange={handleFileChange} />
                            </div>
                        </div>
                        : null
                    }
                    <div class="col-md-12 form-group">
                        <button className="btn btn-block btn-primary" onClick={handleUpdateProfile}>Update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    loginStatus: (IsLogin) => dispatch(signin(IsLogin)),
    loginInfo: (CustInfo) => dispatch(customer(CustInfo))
})

export default connect(null, mapDispatchToProps)(withRouter(UpdateProfileNew));